import { ITypedReduxAction } from '../../types/redux/actionType';
import { TChatListSetSucceedPayload } from '../chatList';

export enum ESpamListActionTypes {
  SetPending = 'chats/spamList/setPending',
  SetSucceed = 'chats/spamList/setSucceed',
  SetFailed = 'chats/spamList/setFailed',
}

export interface ISpamListRequest {
  timestampSpam?: number;
}

export type TSpamListActions =
  | ITypedReduxAction<ESpamListActionTypes.SetPending, ISpamListRequest>
  | ITypedReduxAction<ESpamListActionTypes.SetSucceed, TChatListSetSucceedPayload>
  | ITypedReduxAction<ESpamListActionTypes.SetFailed, void>;
